<template>
    <div class="container">
        404
    </div>
</template>

<script>
export default {}
</script>
